import {
  Component,
  OnInit,
  AfterViewInit,
  Output,
  EventEmitter,
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PlatformLocation} from '@angular/common';
import {ApiService} from '../app/api.service';
import {CommonService} from './common.service';
import {TokenService} from '../app/tokenService.service';

@Component({
  selector: 'scorm-course-component',
  templateUrl: './scorm-course.component.html',
  styleUrls: [],
})
export class ScormCourseComponent implements OnInit, AfterViewInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private platformLocation: PlatformLocation,
    private commonService: CommonService,
    private tokenService: TokenService
  ) {
  }

  courseList: any = [6001];//智能陪练课程数组，用于判断是否跳转到智能陪练去,以后有了新课就加在这个数组里

  async ngOnInit() {
    await this.tokenService.setTokenAndUserId();
    this.apiService.setHeaders();//header设置
    console.log('进入scorm-course');
    this.route.params.subscribe(params => {
      console.log('params', params);
      let learningPathMetaId = params['learningPathMetaId'];
      if (learningPathMetaId === '' || learningPathMetaId === undefined) {
        console.error('未找到learningPathMetaId');
        return;
      } else {
        if (learningPathMetaId.includes(this.courseList)) {
          this.getOrCreateLearningPath(String(learningPathMetaId)).then(res=>{
            let exerciseIds = params['exerciseIds'] ? params['exerciseIds'] : '';
            this.platformLocation['location']['href'] = window.location.origin + '/ai/aicoach/list/' + learningPathMetaId + '?device=pc' + `&exerciseIds=${exerciseIds}` + '&transtalent_token=' + this.tokenService.findToken();
          })
        } else {
          let link;
          if (Number(learningPathMetaId) !== 0) {
            console.log('开始跳转learning-path');
            link = ['learning-path', learningPathMetaId];
            // 使用 replaceUrl 替换当前 history 记录，避免新增一条浏览器返回记录
            this.router.navigate(link, { replaceUrl: true });
          } else {
            console.log('开始跳转survey');
            this.apiService.ajax({
              'type': 'get',
              'url': '/sr/v2/learningtournew'
            }).toPromise().then((res => {
              link = ['survey', res.tour_id, 1, 2];
              this.commonService.setStorage('dnaReturnUrl', location.href);
              // 使用 replaceUrl 替换当前 history 记录，避免新增一条浏览器返回记录
              this.router.navigate(link, { replaceUrl: true });
            }));
          }
        }
      }
    });
  }

  ngAfterViewInit() {
  }

  // 根据learningPathMetaId创建或者获取LearningPath
  getOrCreateLearningPath(learningPathMetaId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/user/learningpathes/'+learningPathMetaId
    }).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/scorm-course.component.ts